import { useEffect, useState } from 'react';
import { get } from '../api/client.js';

/**
 * useAppVersion — 讀 build-info 蓋章（ops/deploy.sh 部署時寫入）。
 * 一次取，不輪詢；失敗回 null（呼叫端自行不顯示）。
 * 版號本身不含租戶資訊，任何登入帳號都看得到 —— 跟哨兵警示（super_admin 限定）分開。
 */
export default function useAppVersion() {
    const [ver, setVer] = useState(null);

    useEffect(() => {
        let cancelled = false;
        get('/api/sip-relay/version')
            .then((r) => { if (!cancelled) setVer(r); })
            .catch(() => {});
        return () => { cancelled = true; };
    }, []);

    return ver;
}
